export default __webpack_public_path__ + "static/media/david_shearer.16fae0e7.mp4";